import {
    getAxiosInstance,
    getRouteInstance,
    baseURL,
    getStoreInstance
} from '@moeinmdn/mixitweb-front-modules/src/plugin/utils/setInstance.js'


export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getResources({commit, state}, page = 1) {
            const axios = getAxiosInstance()
            return axios.get(`/resource-counter`)
        },
        getBanner({commit, state}, slug) {
            const axios = getAxiosInstance()
            return axios.get(`https://api.mixitweb.com/api/content/${slug}`)
        },
    },
    getters: {}
}